import React from 'react';
import {Navigate, Route} from 'react-router-dom';
import { AppRouteConfig } from '../../routes/route.types';

const resolveElement = (
  route: AppRouteConfig,
): React.ReactElement | undefined => {
  if (!route.element) return undefined;
  return React.createElement(route.element, route.props);
};

export const renderRoutes = (routes: AppRouteConfig[]): React.ReactElement[] =>
  routes.map((route, index) => {
    const key = `${route.path ?? (route.index ? 'index' : 'group')}-${index}`;

    const element = route.redirectTo ? (
      <Navigate replace to={route.redirectTo} />
    ) : (
      resolveElement(route)
    );

    if (route.index) {
      return <Route key={key} index element={element} />;
    }

    return (
      <Route key={key} path={route.path} element={element}>
        {route.children ? renderRoutes(route.children) : null}
      </Route>
    );
  });